<template>
  <div class="row search-filter-category">
    <div class="col-12">
      <a v-b-toggle="`collapse-${fieldName}-filter-facet`" class="facet-collapse-icon c-pointer">
        <font-awesome-icon
          class="when-opened "
          icon='caret-down'
          size="lg" />
        <font-awesome-icon
          class="when-closed fa-w-10"
          icon='caret-right'
          size="lg" />
      </a>
      <span class="font-weight-bold ">{{ title }}</span>
      <b-collapse :id="`collapse-${fieldName}-filter-facet`"
        class="row"
        :visible="initialSearchCategoryStates[fieldName]"
      >
        <div class="search-filter-list">
          <div class="search-panel-items col-md-12"
            v-for="entry in entries"
            :key="entry">
            <div class="row multi-text-entry-row"><div class="col-md-8">{{ entry }}</div>
              <div class="col-md-4">
                <a class="text-danger mr-2 mb-2"
                  @click="deleteEntry(entry)"
                  :aria-label="'Delete'">
                  <font-awesome-icon icon="trash-alt" fixed-width />
                </a>
              </div>
            </div>
          </div>
          <div class="search-panel-items sub-search-type-filter">
            <b-input-group
              name="searchItems"
              class="scrollable-section search-panel-items row"
            >
              <input class="form-control"
                v-validate="'numeric|min:1'"
                v-bind:placeholder="placeholderText"
                :name="fieldName"
                :data-vv-as="title"
                v-model="newEntry">
              <div class="input-group-append">
                <b-button class="mr-2 mb-2"
                  :disabled="newEntry === ''"
                  @click="addToEntries(newEntry)"
                  :aria-label="'Add'">
                  Add
                </b-button>
              </div>
            </b-input-group>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>
<script>

export default {
  name: 'MultiTextSearchFacet',
  props: {
    entityType: {
      type: String,
      default: 'Property',
    },
    title: {
      type: String,
    },
    fieldName: {
      type: String,
    },
    placeholderText: {
      type: String,
    },
  },
  data() {
    return {
      newEntry: '',
    };
  },
  computed: {
    initialSearchCategoryStates() {
      return this.$store.state.Search.initialSearchCategoryStates;
    },
    entries: {
      get() {
        return this.$store.state.Search.selectedSearchFacets[this.fieldName];
      },
      set(value) {
        this.setFacet(this.fieldName, value);
      },
    },
  },
  methods: {
    addToEntries(entry) {
      this.entries.push(entry);
      this.newEntry = '';
    },
    setFacet(fieldName, value) {
      this.$store.dispatch(
        'Search/updateSearchFacet',
        {
          type: fieldName,
          values: value,
        },
      );
    },
    deleteEntry(entry) {
      this.entries.splice(this.entries.indexOf(entry), 1);
    },
  },
};
</script>
